module.exports = __webpack_public_path__ + "static/media/reference-slider-23.8d556461.jpg";